var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg4B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "matrix(1 0 0 1 0 -987.362121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path3336"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.14,
    fill: "#800080",
    fillRule: "evenodd",
    stroke: "#000000",
    d: "M0.84 1019.86 C0.84 1002.35 15.03 988.13 32.51 988.13 C49.98 988.13 64.17 1002.35 64.17 1019.86 C64.17 1037.36 49.98 1051.59 32.51 1051.59 C15.03 1051.59 0.84 1037.36 0.84 1019.86 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3338"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.14,
    fill: "#ffffff",
    fillRule: "evenodd",
    stroke: "#000000",
    d: "M18.47 1019.53 C18.47 1011.95 24.52 1005.79 31.96 1005.79 C39.41 1005.79 45.46 1011.95 45.46 1019.53 C45.46 1027.11 39.41 1033.27 31.96 1033.27 C24.52 1033.27 18.47 1027.11 18.47 1019.53 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tspan3344",
    transform: "matrix(1.0075 0 0 0.992556 23.775583 1005.746276)"
  }, /*#__PURE__*/React.createElement("text", {
    kerning: 0,
    fontFamily: ".AppleSystemUIFont",
    fontWeight: 700,
    fontSize: 22.21
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21.48
  }, "4"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4B);
export default __webpack_public_path__ + "static/media/4B.7d11eb5923c95a35c4c619a8770499f0.svg";
export { ForwardRef as ReactComponent };